import React from 'react'

import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'
import {DealFreezeBannerCard} from '@vio/shared/src/dealFreeze/components/common/DealFreezeBannerCard'

export const DealFreezeBanner: React.FC = () => (
  <DealFreezeBannerCard
    title={
      <FormattedMessageWrapper
        id="dealFreeze.bannerFreezeDeal"
        defaultMessage="Freeze a deal"
      />
    }
    tagLabel={
      <FormattedMessageWrapper
        id="dealFreeze.roomBannerFreezableDeal"
        defaultMessage="Freezable deal"
      />
    }
  >
    <FormattedMessageWrapper
      id="dealFreeze.bannerSubtitle"
      defaultMessage="Secure the price and availability, no card details required."
    />
  </DealFreezeBannerCard>
)
